import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { StepGuard } from '@guards/step.guard';
import { GuestSearchComponent } from '@components/guest-search/guest-search.component';
import { GuestVerifyComponent } from '@components/guest-verify/guest-verify.component';
import { CreditAssignComponent } from '@components/credit-assign/credit-assign.component';
import { SummarySendComponent } from '@components/summary-send/summary-send.component';
import { ReservationListComponent } from '@components/reservation-list/reservation-list.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/search',
    pathMatch: 'full'
  },
  {
    path: 'search',
    component: GuestSearchComponent,
    canActivate: [MsalGuard, StepGuard]
  },
  {
    path: 'verify',
    component: GuestVerifyComponent,
    canActivate: [MsalGuard, StepGuard]
  },
  {
    path: 'credit',
    component: CreditAssignComponent,
    canActivate: [MsalGuard, StepGuard]
  },
  {
    path: 'send',
    component: SummarySendComponent,
    canActivate: [MsalGuard, StepGuard]
  },
  {
    path: 'search-results',
    component: ReservationListComponent,
    canActivate: [MsalGuard]
  },
  {
    path: '**',
    redirectTo: '/search'
  }
];
